module.exports = __webpack_public_path__ + "static/img-25-577bd7893361e52e5b267586addcddd4.jpeg";